import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    notification: {
      message_antes: '',
      message: '',
      type: 'primary',
      show: false,
      color: 'primary',

    },
    notificationMessage: {
      message: '',
      show: false,
      color: 'white',
      subiendo: 0,
    },
    subiendoLectura: {
      cliente: '',
      estado: 0, //  0: pendiente, 1: subiendo, 2: subida, 3: error
    },
    actualizarApp: {
      estado: false,
      mensaje: 'xd xd xd',
      actualizar: false,
      tipo: 0,
    }



  },
  mutations: {
    SHOW_NOTIFICATION(state, { message, type, color }) {
      // console.log('cargando SHOW_NOTIFICATION');
      state.notification.message = message;
      state.notification.type = type;
      state.notification.show = true;
      state.notification.color = color;
    },
    HIDE_NOTIFICATION(state) {
      state.notification.show = false;
    },
    SHOW_NOTIFICATION_MESSAGE(state, { message, color, subiendo }) {
      state.notificationMessage.message = message;
      state.notificationMessage.show = true;
      state.notificationMessage.color = color;
      state.notificationMessage.subiendo = subiendo;
    },
    HIDE_NOTIFICATION_MESSAGE(state) {
      state.notificationMessage.show = false;
    },
    SHOW_SUBIENDO_LECTURAS(state, { cliente, estado }) {
      state.subiendoLectura.cliente = cliente;
      state.subiendoLectura.estado = estado;
    },
    SHOW_ACTUALIZAR_APP(state, { estado, mensaje, actualizar, tipo }) {
      state.actualizarApp.estado = estado;
      state.actualizarApp.mensaje = mensaje;
      state.actualizarApp.actualizar = actualizar;
      state.actualizarApp.tipo = tipo;
    },
  },
  actions: {
    triggerNotification({ commit }, { message, type = 0, color = 'primary', timeout = 0 }) {
      const message_antes = this.state.notification.message;
    
      // Verificar si el mensaje es diferente al anterior
      if (message_antes !== message) {
        this.state.notification.message = message;
        commit('SHOW_NOTIFICATION', { message, type, color });

        // Configurar el tiempo para ocultar la notificación si timeout es mayor a 0
        if (timeout > 0) {
          setTimeout(() => {
            commit('HIDE_NOTIFICATION');
          }, timeout);
        }
      }
    },
    clearNotification({ commit }) {
      commit('HIDE_NOTIFICATION');
    },

    //para mostrar otro tipo de notificaciones 
    triggerNotificationMessage({ commit }, { message, timeout = 0, color = 'white', subiendo = 0 }) {
      commit('SHOW_NOTIFICATION_MESSAGE', { message, color, subiendo });
      if (timeout > 0) {
        setTimeout(() => {
          commit('HIDE_NOTIFICATION_MESSAGE');
        }, timeout);
      }
    },
    clearNotificationMessage({ commit }) {
      commit('HIDE_NOTIFICATION_MESSAGE');
    },

    //para las lecturas pendientes 
    triggerLecturaPendiente({ commit }, { cliente, estado }) {
      console.log('VUEX==== cargando triggerLecturaPendiente');

      commit('SHOW_SUBIENDO_LECTURAS', { cliente, estado });
      // if (timeout > 0) {
      //   setTimeout(() => {
      //     commit('HIDE_NOTIFICATION_MESSAGE');
      //   }, timeout);
      // }
    },


    triggerActualizarApp({ commit }, { estado, mensaje, actualizar = false , tipo = 0}) {

      commit('SHOW_ACTUALIZAR_APP', { estado, mensaje, actualizar, tipo });
    }
  },
  getters: {
    notification: (state) => state.notification,
    notificationMessage: (state) => state.notificationMessage,
    XsubiendoLectura: (state) => state.subiendoLectura,
    XactualizarApp: (state) => state.actualizarApp,
  }
});
